<template>
  <div
    :class="[
      'general-info',
      customClass || 'col-12 col-sm-6 col-md-4 col-xl-2',
    ]">
    <h5 class="title">{{ $t(label) }}</h5>
    <p class="value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    customClass: String,
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--color-132);
  margin-block: 4px;
  text-wrap: nowrap;
}
.value {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--color-115);
  margin-bottom: 0.5rem;
}
</style>

